// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a065e3a4","239":"4f990335","453":"d420ea71","667":"667b2cc7"}[chunkId] + ".chunk.js";
};